var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalApplicationBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.535 12.465a4.998 4.998 0 010 7.07 5.005 5.005 0 01-7.07 0 4.998 4.998 0 010-7.07 4.998 4.998 0 017.07 0M9.867 5.496v.008-.008M7.324 5.496v.008-.008M4.777 5.488V5.5v-.012M2 8h17",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 11.418V5c0-1.105-.895-2-2-2H4c-1.105 0-2 .895-2 2v11c0 1.105.895 2 2 2h8.418M19.223 14.89l-2.778 2.778L14.777 16",
    strokeWidth: 1.5
  }))));
}
export default SvgDigitalApplicationBlue;


//////////////////
// WEBPACK FOOTER
// ./src/icons/digitalApplicationBlue.svg
// module id = 759
// module chunks = 13